// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"vv_a bhf_b"};